module.exports = __webpack_public_path__ + "static/media/img_PP.1d013c74.jpg";